import React from 'react';
//import logo from './assets/visioN.svg';
import '../App.less';
import { 
    Button,
    Typography, 
    Divider,
    Row, 
    Col,
    Card,
    Image,
    Space,
    Avatar,
    Tabs
  } from 'antd';

import { Link } from "react-router-dom";

const { 
  Text, 
  Title
} = Typography;

const gridStyle = {
  width: '50%',
  textAlign: 'center',
};

function UIUX() {
    return (
        <div>
          
          <Row className="p16-t" justify="space-between">
            <Title level={3}>My Library on Unacademy Learner App</Title>
          </Row>
          <Row className="p16-t" justify="space-between">
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <div>
                    <iframe src="https://cdn.dribbble.com/users/276151/videos/8950/unacademy-my-library-saved.mp4" className="fullWidthVideo m8-b" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
              <Text className="imgDesc">With the introduction of "saved" button throughout the app, learners could now save more courses to "My Library". The design of the existing "My Library" was not scalable to handle so much more content. Attempt to club all saved and downloaded courses in one screen. Exposing recently accessed lists too. Learners could now download saved courses while in "My Library", previously they had to open every course and then download.</Text>
            </Col>
          </Row>

          <Row className="p48-t" justify="space-between">
            <Title level={3}>Statistics on Unacademy Educator App</Title>
          </Row>
          <Row className="p16-t" justify="space-between">
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Image className="divImage m8-b" src="https://cdn.dribbble.com/users/276151/screenshots/5130038/statistics.gif"/>
            </Col>
            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
              <Text className="imgDesc">Enabling Educators on Unacademy platform with data! Educators can now see the no. of lesson views, lesson published, average ratings, followers gained and make much more sense out of this by comparing all data to previous time period. They can also see the delta between the two time periods, shown in green(increase) and red(decrease). Statistics can be viewed as lifetime, last 30 days, current month and last 7 days. Have also included a touchpoint to collect better feedback for this screen.</Text>
            </Col>
          </Row>
          

          <Row className="p48-t" justify="space-between">
            <Title level={3}>Leaderboard Unacademy App</Title>
          </Row>
          <Row className="p16-t" justify="space-between">
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Image className="divImage m8-b" src="https://cdn.dribbble.com/users/276151/screenshots/4962391/leaderboard.gif"/>
            </Col>
            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
              <Text className="imgDesc">Looking at the staggering amount of time learners spend on the app, we decided to appreciate and motivate them to learn more!Now, as a learner I can see what courses the top ranking learners are going through. Previously there was no way to reach another learner's profile.Here's to celebrating our users 🍻</Text>
            </Col>
          </Row>

          <Row className="p48-t" justify="space-between">
            <Title level={3}>UX at Unacademy</Title>
          </Row>
          <Row className="p16-t" justify="space-between">
            <Text className="imgDesc">I've compiled some of the experiments performed and the process. There are 4 sections to this. Onboarding, Discovery, Consumption and Miscellaneous. You might notice a lack of wireframes as we got a design component system in place within the year which enabled us to iterate faster.</Text>
            <a href="https://paper.dropbox.com/doc/UX-at-Unacademy--BG5WcVWHbctbpvCc7skhsIexAQ-Yhk1fc6adk6Gh2aInP5xf" target="_blank" rel="noopener noreferrer">
              <Button type="primary" className="p12 m16-t divImage">
                <div className="second">Dig into it</div>
              </Button>    
            </a>
          </Row>

          <Row className="p48-t" justify="space-between">
            <Title level={3}>Homepage clearTax</Title>
          </Row>
          <Row className="p16-t" justify="space-between">
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Image className="divImage m8-b" src="https://cdn.dribbble.com/users/276151/screenshots/3673107/home-page-mobile.gif"/>
            </Col>
            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
              <Text className="imgDesc">clearTax had released Financial Marketplace in September, 2016. To reflect the launch of Marketplace and the move of clearTax from just a Tax filing website to a platform providing more financial services, this was designed</Text>
            </Col>
          </Row>
        </div>
        );
  }
  
export default UIUX;
